import React from 'react';
import SubTable from 'src/components/commons/subTable';
import PageContainer from 'src/components/pageContainer/PageContainer';
import { CustomLoadingModal } from 'src/components/commons/customModal';
import useAddressTypeTable from './hooks/useAddressTypeTable';
import StyleInfinityScroll from '../../../../styles/StyleInfinityScroll.style';

const TabAddressType = () => {
  const {
    autocompleteFieldSearch,
    handleFilterChange,
    handleSortModelChange,
    setColumns,
    columns,
    newRecord,
    spinning,
    postData,
    createNewRecord,
    handleUpdateRows,
    onListRender,
    resetNewRecord,
    dataSource,
    handleClearFilter,
    handleDeleteRows,
  } = useAddressTypeTable();

  return (
    <>
      {spinning && <CustomLoadingModal modalStatus />}
      <PageContainer margin='2rem'>
        <StyleInfinityScroll>
          <SubTable
            data={dataSource || []}
            onListRender={onListRender}
            columns={columns}
            setColumns={setColumns}
            autocompleteFieldProvider={autocompleteFieldSearch}
            onFilterChange={handleFilterChange}
            onSortChange={handleSortModelChange}
            scroll={{ y: '60vh', x: '90vw' }}
            actionCell={['delete']}
            headerActions={['filter', 'edit', 'delete']}
            id='sub-table-address-type'
            showOptionFilterLeft={false}
            allowGlobalEditActive
            total
            nonGlobalFilterable
            showAutoIncrement
            handleUpdateRows={handleUpdateRows}
            onDeleteClick={handleDeleteRows}
            newRecord={newRecord}
            postData={postData}
            saveNewRecord={createNewRecord}
            resetNewRecord={resetNewRecord}
            clearFilter={handleClearFilter}
            columnFilterShown
          />
        </StyleInfinityScroll>
      </PageContainer>
    </>
  );
};
export default TabAddressType;
